<template>
  <div class="nav">
    <img src="@/assets/pictures/bg2.png"/>
<!--这个是深色导航栏和浅色字体（如需要，放在el-menu中）-->
<!--    background-color="#545c64"-->
<!--    text-color="#fff"-->
<!--    active-text-color="#ffd04b"-->
    <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        :router="true"
        active-text-color="green">

      <el-submenu index="1" v-show="isUser">
        <template slot="title">
          <i class="el-icon-search"></i>
          <span style="font-size: 16px;font-weight: bold">{{$t("Navigation.Data Search Module")}}</span>
        </template>

        <el-menu-item-group>
          <el-tooltip class="item" effect="dark" :content="$t('Navigation.City Evaluation System1')" placement="right-start">
            <el-menu-item index="/rateSystemSearch">
              <span slot="title">{{$t("Navigation.City Evaluation System")}}</span>
            </el-menu-item>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('Navigation.City Detail Data1')" placement="right-start">
            <el-menu-item index="/detailDataSearch" >
              <span slot="title">{{$t("Navigation.City Detail Data")}}</span>
            </el-menu-item>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('Navigation.City Index Rank1')" placement="right-start">
            <el-menu-item index="/rateRankSearch">
              <span slot="title">{{$t("Navigation.City Index Rank")}}</span>
            </el-menu-item>
          </el-tooltip>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="2" v-show="isUser">
        <template slot="title">
          <i class="el-icon-pie-chart"></i>
          <span style="font-size: 16px;font-weight: bold">{{$t("Navigation.Data Analysis Module")}}</span>
        </template>


        <el-menu-item-group>
          <el-tooltip class="item" effect="dark" :content="$t('Navigation.Comparative Analysis of City Data1')" placement="right-start">
            <el-menu-item index="/compareDataSearch">
              <span slot="title">{{$t("Navigation.Comparative Analysis of City Data")}}</span>
            </el-menu-item>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('Navigation.Trend Analysis of City Data1')" placement="right-start">
            <el-menu-item index="/changeDataSearch" >
              <span slot="title">{{$t("Navigation.Trend Analysis of City Data")}}</span>
            </el-menu-item>
          </el-tooltip>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="3" v-show="isUserManager">
        <template slot="title">
          <i class="el-icon-edit"></i>
          <span style="font-size: 16px;font-weight: bold">{{$t("Navigation.Account Management Module")}}</span>
        </template>

        <el-menu-item-group>
          <el-menu-item index="/userChange">
            <span slot="title">{{$t("Navigation.Account Permission Modification")}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="4" v-show="isDataManager">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span style="font-size: 16px;font-weight: bold">{{$t("Navigation.Data Maintenance Module")}}</span>
        </template>

        <el-menu-item-group>
          <el-tooltip class="item" effect="dark" :content="$t('Navigation.City Management1')" placement="right-start">
            <el-menu-item index="/cityManage">
              <span slot="title">{{$t("Navigation.City Management")}}</span>
            </el-menu-item>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" :content="$t('Navigation.Index Management1')" placement="right-start">
            <el-menu-item index="/indexManage" >
              <span slot="title">{{$t("Navigation.Index Management")}}</span>
            </el-menu-item>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" :content="$t('Navigation.Data Management1')" placement="right-start">
            <el-menu-item index="/dataManage">
              <span slot="title">{{$t("Navigation.Data Management")}}</span>
            </el-menu-item>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" :content="$t('Navigation.Index calculation1')" placement="right-start">
            <el-menu-item index="/calculateScore">
              <span slot="title">{{$t("Navigation.Index calculation")}}</span>
            </el-menu-item>
          </el-tooltip>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="5" v-show="isUploader">
        <template slot="title">
          <i class="el-icon-upload2"></i>
          <span style="font-size: 16px;font-weight: bold">{{$t("Navigation.Data Upload Module")}}</span>
        </template>

        <el-menu-item-group>
          <el-menu-item index="/dataUpload">
            <span slot="title">{{$t("Navigation.Batch Data Upload")}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="6" v-show="isVerifier">
        <template slot="title">
          <i class="el-icon-s-check"></i>
          <span style="font-size: 16px;font-weight: bold">{{$t("Navigation.Data Audit Module")}}</span>
        </template>

        <el-menu-item-group>
          <el-menu-item index="/dataVerifyNav">
            <span slot="title">{{$t("Navigation.Batch Data Audit")}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>


      <el-submenu index="7">
        <template slot="title">
          <i class="el-icon-video-camera"></i>
          <span style="font-size: 16px;font-weight: bold">{{$t("Navigation.Video Train Module")}}</span>
        </template>

        <el-menu-item-group>
          <el-menu-item index="/videoTrain">
            <span slot="title">{{$t("Navigation.Video Train")}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

    </el-menu>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "Navigation",
  data(){
    return{
      roles:[],
      isUser:false,
      isUserManager:false,
      isDataManager:false,
      isUploader:false,
      isVerifier:false
    }
  },
  methods: {
    getUser(){
      let that=this
      request.get('/sysUser/currentUser').then(function(res){
        that.roles=res.data.roles
        that.roles.forEach(function (role){
          if(role.id==1){that.isUserManager=true}
          if(role.id==2){that.isUploader=true}
          if(role.id==3){that.isVerifier=true}
          if(role.id==4){that.isDataManager=true}
          if(role.id==5||role.id==6||role.id==7||role.id==8||role.id==9||role.id==10||role.id==11||role.id==12||role.id==13||role.id==14||role.id==15||role.id==16||role.id==17||role.id==18||role.id==19||role.id==20||role.id==21||role.id==22||role.id==23||role.id==24||role.id==25||role.id==26||role.id==27){that.isUser=true}
        })
      }).catch(function (err){
        console.log(err)
      })
    }
  },
  mounted() {
    this.getUser()
  }
}
</script>

<style scoped>
.nav {
  overflow: hidden;
}
</style>